import React from 'react';
import { AlertTriangle, CheckCircle2, CircleDashed, HelpCircle, MapPin, Search } from 'lucide-react';
import { EXPORT_DATE_LABEL } from '../../data/world/package';
import type { WorldData } from '../../types/world';

/*
 * Estado de cada dato, por separado. El verde solo se usa para lo respaldado por la configuración
 * exportada (forma de obtención o ubicación). "Comprobado en el juego" requiere una prueba real
 * documentada; hoy no hay ninguna, así que no se muestra en ninguna ficha.
 */
export type DataStatusKind = 'catalog' | 'route' | 'location' | 'partial' | 'conflict' | 'unchecked' | 'tested';
const cfg: Record<DataStatusKind, {
  label: string;
  cls: string;
  Icon: typeof CheckCircle2;
}> = {
  catalog: {
    label: 'Ítem identificado en el catálogo',
    cls: 'border-white/15 bg-white/[0.04] text-gray-300',
    Icon: Search
  },
  route: {
    label: 'Forma de obtención documentada',
    cls: 'border-emerald-400/30 bg-emerald-400/10 text-emerald-200',
    Icon: CheckCircle2
  },
  location: {
    label: 'Ubicación documentada',
    cls: 'border-emerald-400/30 bg-emerald-400/10 text-emerald-200',
    Icon: MapPin
  },
  partial: {
    label: 'Información parcial',
    cls: 'border-amber-300/30 bg-amber-300/10 text-amber-100',
    Icon: CircleDashed
  },
  conflict: {
    label: 'En revisión',
    cls: 'border-red-300/30 bg-red-300/10 text-red-100',
    Icon: AlertTriangle
  },
  unchecked: {
    label: 'No comprobado',
    cls: 'border-white/15 bg-white/[0.04] text-gray-400',
    Icon: HelpCircle
  },
  tested: {
    label: 'Comprobado en el juego',
    cls: 'border-sky-300/30 bg-sky-300/10 text-sky-100',
    Icon: CheckCircle2
  }
};
export function DataStatus({
  kind,
  label,
  withDate
}: {
  kind: DataStatusKind;
  label?: string;
  withDate?: boolean;
}) {
  const c = cfg[kind];
  const showDate = withDate ?? (kind === 'route' || kind === 'location');
  return <span className={`inline-flex items-center gap-1 rounded-full border px-2 py-0.5 text-[11px] font-semibold ${c.cls}`} data-id="element-1138" data-mp="35jnmds82yls6">
      <c.Icon className="h-3 w-3 shrink-0" aria-hidden="true" data-id="element-1139" data-mp="30m48wuj7id1a" />
      {label ?? c.label}
      {showDate && <span className="font-normal opacity-80" data-id="element-1140" data-mp="14izgpco9vsq7">· config. {EXPORT_DATE_LABEL}</span>}
    </span>;
}

/** Archivos necesarios que no se cargaron (para mostrar "No comprobado" en lugar de "sin drops"). */
export function missingFiles(w: WorldData, keys: string[]): string[] {
  return keys.filter(k => !w.reports.find(r => r.key === k)?.loaded);
}